import { defineMessages } from 'react-intl';

export default defineMessages({
    vehicleX: {
        id: 'ml.quoteandbind.pa.hvq.discrepancies.Vehicle X',
        defaultMessage: 'Vehicle {index}'
    },
    driverX: {
        id: 'ml.quoteandbind.pa.hvq.discrepancies.Driver X',
        defaultMessage: 'Driver {index}'
    },
    priorInsurance: {
        id: 'ml.quoteandbind.pa.hvq.discrepancies.Prior Insurance',
        defaultMessage: 'Prior Insurance'
    },
    nextLabel: {
        id: 'ml.quoteandbind.pa.hvq.discrepancies.We\'ll review <strong>your driver information</strong> next',
        defaultMessage: 'We\'ll review {yourDriverInfo} next'
    },
    yourDriverInfo: {
        id: 'ml.quoteandbind.pa.hvq.discrepancies.your driver information',
        defaultMessage: 'your driver information'
    },
    mlPAHVQConsumerDiscrepanciesHeader: {
        id: 'ml.quoteandbind.pa.hvq.discrepancies.infoNotMatchRecord',
        defaultMessage: 'Some of the information you provided does not match our records. Please update by selecting the correct information.'
    },
    validateYourInfo: {
        id: 'ml.quoteandbind.pa.hvq.discrepancies.Validate your information',
        defaultMessage: 'Validate your information'
    }
});
